export enum RealEstateAgentState {
    Draft,
    Active,
    Inactive,
}
